import {ErrorManager} from "../../helpers/field-error";
import {F_ERR_ENUM} from "../../enum/field-error.enum";

export function hasValue(field) {
  return {
    computed: {
      hasValue() {
        return (this[field] !== '' && this[field] !== undefined) ? 'has-value' : '';
      }
    }
  }
}

export const withErrors = {
  props: {
    errorMessage: String,
    useDynamicErrors: {
      type: Boolean,
      default: false
    },
    usePseudoDynamicErrors: {
      type: Boolean,
      default: true
    },
    cleanErrorsOnInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalErrors: []
    }
  },
  computed: {
    hasError() {
      return !!this.errorMessage || this.internalErrors.length > 0;
    },
    currentErrorMessage() {
      return ErrorManager.display(this.internalErrors.concat([ErrorManager.factory(F_ERR_ENUM.PROP, this.errorMessage)]));
    }
  },
  mounted() {
    this.$on('input', () => {
      if (this.cleanErrorsOnInput) {
        this.setError(F_ERR_ENUM.ALL, null);
      }
    })
  },
  methods: {
    setError(source, message, onNextTick = false) {
      const fn = () => {
        if (!message) {
          this.internalErrors = ErrorManager.filter(this.internalErrors, source);
          this.$emit('error', this.internalErrors.length > 0);
          return;
        }
        this.internalErrors = ErrorManager.add(this.internalErrors, ErrorManager.factory(source, message));
        this.$emit('error', this.internalErrors.length > 0);
      };
      if (onNextTick) {
        this.$nextTick(fn);
        return !!message;
      }
      fn();
      return !!message;
    },
    computeErrors() {

    }
  }
};

export const withEventDispatcher = {
  methods: {
    handleInput(e) {
      this.$emit('input', e)
    },
    handleKeyDown(e) {
      this.$emit('keydown', e)
    },
    handleKeyPress(e) {
      this.$emit('keypress', e)
    },
    handleClick(e) {
      this.$emit('click', e)
    }
  }
};

export const withIcon = {
  props: {
    icon: String
  },
  computed: {
    inputClass() {
      const classes = ['form-control'];
      if (this.icon) {
        classes.push('icon', this.icon + '-icon');
      }
      if (this.error) {
        classes.push('errored');
      }
      return classes;
    }
  }
};

export const withPlaceholder = {
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      placeholderSuffix: ''
    }
  },
  computed: {
    hasPlaceholder () {
      return !!this.placeholder;
    },
    placeholderAsProp () {
      return this.hasPlaceholder ? this.placeholder + ' ' + this.placeholderSuffix : '';
    }
  }
};

export const initializable = {
  props: {
    value: String
  },
  data() {
    return {
      content: ''
    }
  },
  watch: {
    value(o) {
      if (!o) {
        this.content = '';
        return;
      }
      this.content = o;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixins/input.mixin.js